import React from 'react'
import { TagSection } from '../components/TagSection'
import './TagToolbar.css';

export class TagToolbar extends React.Component {
    addTag = () => {

    }
    render() {
        const { onAdd } = this.props;
        return (
                <TagSection onAdd={onAdd} />
        )
    }
}